import { buildExpertReportItemPath } from '@/entities/expert-report';

/** Определение оценки, на котором открывается карточка его единицы оценивания */
export const KM_EVAL_TARGET_PARAM = 'evalId';

/**
 * Адрес определения оценки в разделе экспертных заключений.
 *
 * Своего места в разделе у определения нет — оно живёт внутри карточки единицы оценивания,
 * поэтому адресуется этой карточкой, открытой на нём: единица и определение в ней.
 */
export const buildKmEvalPath = (reportId: number, assessmentId: number, evalId: number): string => {
  const path = buildExpertReportItemPath(reportId, 'assessment', assessmentId);

  return `${path}?${new URLSearchParams({ [KM_EVAL_TARGET_PARAM]: String(evalId) })}`;
};
